import React, { Component } from "react";
import LoadingCell from "./LoadingCell";

class LoadingMenu extends Component {
  render() {
    const { cellHeight, settings } = this.props;
    const productClassName = settings.product_per_row
      ? "col-12 mb-5 center-items"
      : "row px-2 w-100 mx-auto";
    return (
      <div className={productClassName}>
        <LoadingCell cellHeight={cellHeight} />
        <LoadingCell cellHeight={cellHeight} />
        <LoadingCell cellHeight={cellHeight} />
        <LoadingCell cellHeight={cellHeight} />
      </div>
    );
  }
}

export default LoadingMenu;
